<template>
	<div
		class="delivery-specifications"
		v-if="format">
		<div
			class="grid grid--gutters grid--center-vertical grid--ms-full"
			v-if="!overview">
			<div class="cell">
				<h3
					class="title--dot"
					v-text="selectedProduct.name + ' ' + formatInfo.fullName"/>
				<table class="configurator-overview__table mt-m">
					<template v-if="!customFormat.bool">
						<tr>
							<td class="configurator-overview__table-title">Hoogte</td>
							<td class="configurator-overview__table-text">{{ formatInfo.heightInMm }} mm</td>
						</tr>
						<tr>
							<td class="configurator-overview__table-title">Breedte</td>
							<td class="configurator-overview__table-text">{{ formatInfo.widthInMm }} mm</td>
						</tr>
					</template>
					<template v-else>
						<tr>
							<td class="configurator-overview__table-title">Hoogte</td>
							<td class="configurator-overview__table-text">{{ customFormat.minHeight }}mm tot {{ customFormat.maxHeight }}mm</td>
						</tr>
						<tr>
							<td class="configurator-overview__table-title">Breedte</td>
							<td class="configurator-overview__table-text">{{ customFormat.minWidth }}mm tot {{ customFormat.maxWidth }}mm</td>
						</tr>
					</template>
					<tr v-if="format.bleed > 0">
						<td class="configurator-overview__table-title">Bleed</td>
						<td class="configurator-overview__table-text">{{ format.bleed }}mm</td>
					</tr>
					<tr>
						<td class="configurator-overview__table-title">Verwachtte levering</td>
						<td class="configurator-overview__table-text">{{ standardDelivery.date }}</td>
					</tr>
					<tr v-if="format.isRushOrderAvailable">
						<td class="configurator-overview__table-title">Verwachtte spoedlevering</td>
						<td class="configurator-overview__table-text">{{ rushDelivery.date }}</td>
					</tr>
				</table>
			</div>
			<div class="cell cell--25">
				<div class="configurator-options__shape configurator-options__shape--square">
					<div class="configurator-options__image-holder content-block__image-holder content-block__image-holder--contain">
						<img
							:src="imagePath"
							class="configurator-options__image"
							width="500">
					</div>
				</div>
			</div>
		</div>
		<div class="mt-m">
			<h3
				class="mt-s mb-s title--dot"
				v-if="!overview">Aanleverspecificaties</h3>
			<p>Volg de aanwijzingingen in de werktekening of bekijk de volledige aanleverspecificatie om een drukklaar PDF aan te kunnen leveren. U kunt ook gebruik maken van een InDesign-sjabloon.</p>
			<p v-if="hasEditor">
				Moeite met het aanleveren van uw PDF-bestand? <a :href="editorUrl" class="link">Upload uw PDF-bestand in onze Online Editor</a> en maak het bestand in een paar klikken drukklaar
			</p>
			<p>Heeft u nog vragen over het aanleveren van de bestanden? Neem dan contact op met onze <a href="/contact" class="link">klantenservice</a>.</p>
			<div
				v-if="showBookManual"
				class="cell cell--full alertbox alertbox--notification alertbox--inline mt-m">

				<svg class="alertbox__icon alertbox__icon--notification">
					<use xlink:href="#alert--info" />
				</svg>
				<p class="alertbox__text">
					Hulp nodig met het opmaken van uw document? Gebruik onze
					<a
						class="link" title="Handleiding downloaden"
						href="/content/pdf/indesign-templates-manual-drukwerknodig.pdf" target="_blank">handleiding</a>
					voor indesign-templates met handige tips!
				</p>

			</div>

			<div class="grid grid--gutters grid--l-1-2 grid--ms-full mt-s">
				<div class="cell">
					<a
						:href="pdfPath"
						target="_blank"
						class="button button--cta">
						Aanleverspecificatie
					</a>
				</div>
				<div
					class="cell"
					v-if="!format.isCustomSize">
					<a
						:href="inDesignPath"
						target="_blank"
						class="button">
						InDesign-sjabloon
					</a>
				</div>
				<div
					class="cell"
					v-if="format.pdfTemplatePath">
					<a
						:href="pdfTemplatePath"
						target="_blank"
						class="button">
						PDF-sjabloon
					</a>
				</div>
			</div>
		</div>
		<div class="mt-l">
			<img
				class="content-block__image"
				:src="pngPath"
				:alt="formatInfo.fullName">
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "DeliverySpecification",
	props: {
		format: {
			type: Object,
			required: true
		},
		overview: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapState(["baseProps"]),
		imagePath () {
			return this.format.iconPath;
		},
		pngPath () {
			return this.format.pngPath;
		},
		pdfPath () {
			return this.format.pdfPath;
		},
		inDesignPath () {
			return this.format.inDesignPath;
		},
		pdfTemplatePath () {
			return this.format.pdfTemplatePath;
		},
		formatInfo () {
			return this.format.productSize;
		},
		customFormat () {
			return {
				bool: this.format.isCustomSize,
				minWidth: this.format.minWidthInMm,
				minHeight: this.format.minHeightInMm,
				maxWidth: this.format.maxWidthInMm,
				maxHeight: this.format.maxHeightInMm
			};
		},
		selectedProduct () {
			return this.$store.getters.getSelectedProduct;
		},
		showBookManual () {
			return this.$store.getters.isBookProduct;
		},
		hasEditor () {
			return this.baseProps.hasEditor.toLowerCase() === "true";
		},
		editorUrl () {
			return this.baseProps.editorUrl;
		},
		standardDelivery () {
			return this.$store.getters.getStandardDelivery;
		},
		rushDelivery () {
			return this.$store.getters.getRushDelivery;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/information/delivery-specification.vue